export default class Shape {
    constructor(baseAngle, baseRadius, size, clr, p, code) {
        this.baseAngle = baseAngle;
        this.baseRadius = baseRadius;
        this.size = size;
        this.color = clr;
        this.p = p;
        this.code = code;
        this.drawFunction = new Function('p, size', code);
        this.type = 'circle';
        this.scale = 1;
    }

    display(sliceRotation) {
        let theta = sliceRotation + this.baseAngle;
        let scaleFactor = this.normalizeShapeFunction(this.shapeFunction(theta));
        let finalRadius = this.baseRadius * scaleFactor;
        let x = finalRadius * this.p.cos(theta);
        let y = finalRadius * this.p.sin(theta);

        this.p.fill(this.color);
        this.p.push();
        this.p.scale(this.scale);
        this.p.translate(x / this.scale, y / this.scale);
        switch (this.type) {
        case 'circle':
            try {
                this.drawFunction(this.p, this.size);
            } catch (e) {
                console.warn(e);
            }
            break;
        case 'triangle':
            this.p.triangle(
                -this.size / 2,
                this.size / 2,
                0,
                -this.size / 2,
                this.size / 2,
                this.size / 2
            );
            break;
        case 'square':
            this.p.rectMode(this.p.CENTER);
            this.p.rect(0, 0, this.size, this.size);
            break;
        default:
            this.p.ellipse(0, 0, this.size);
        }
        this.p.pop();
    }

    shapeFunction(theta) {
        let a = 1;
        return a * (1 - this.p.cos(theta));
    }

    normalizeShapeFunction(rawValue) {
        // Normalize (0 to 1)
        let normalizedValue = rawValue / 2;

        // Desired output range
        const minScale = 0.5;
        const maxScale = 1.5;

        // Scale and clamp
        return this.p.map(normalizedValue, 0, 1, minScale, maxScale, true);
    }

    updateCode(code) {
        this.drawFunction = new Function('p, size', code);
    }

    updateScale(scale) {
        this.scale = scale;
    }
}
